import baseURL from "../config/api";
import axios from "../config/axios";

export const getCourseProgress = (courseId: number, userId:number) => {
    return getFetch(`lessons/GetLessonsProgressForUser/${userId},${courseId}`);
}

export const getLessonProgress = (lessonId: number, userId:number) => {
    return getFetch(`sublessons/GetSubLessonsProgressForUser/${userId},${lessonId}`);
}

export const getUserProgress = (userId:number) => {
    return getFetch(`users/GetUserProgressByUserId/${userId}`);
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}
